import { reactive, watch } from "vue";
import color from "@/assets/utils/color";

function applyDirection(rtl) {
  const root = document.documentElement;
  root.classList.toggle("vuesax-app-is-rtl", rtl);
  root.classList.toggle("vuesax-app-is-ltr", !rtl);
  root.setAttribute("dir", rtl ? "rtl" : "ltr");
}

function applyTheme(colors) {
  Object.entries(colors).forEach(([name, value]) => {
    let channels = value;
    if (value.startsWith("#")) {
      const rgb = color.hexToRgb(value);
      channels = `${rgb.r},${rgb.g},${rgb.b}`;
    } else if (value.startsWith("rgb")) {
      channels = value
        .replace(/[rgba()]/g, "")
        .split(",")
        .slice(0, 3)
        .join(",");
    }
    color.setCssVariable(`--vs-${name}`, channels);
  });
}

export function installVsCore(app, options = {}) {
  const vs = reactive({
    rtl: Boolean(options.rtl),
  });

  applyTheme(options.colors || {});
  applyDirection(vs.rtl);
  watch(() => vs.rtl, applyDirection);

  app.config.globalProperties.$vs = vs;
  return vs;
}
